import { useCallback } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { retryFecImport } from '../query-api'

interface RetryFecImportsResult {
  /** Every request that failed. The others were still sent. */
  failures: Array<{ fecImportId: string; reason: unknown }>
  /** The imports the backend accepted for a retry. */
  retriedIds: string[]
}

export const useRetryFecImports = () => {
  const { organization } = useUserOrganization()

  return useCallback(
    async (fecImportIds: string[]): Promise<RetryFecImportsResult> => {
      const organizationId = organization?.id || ''
      const results = await Promise.allSettled(
        fecImportIds.map((fecImportId) => retryFecImport(organizationId, fecImportId)),
      )
      const result: RetryFecImportsResult = { failures: [], retriedIds: [] }

      for (const [index, settled] of results.entries()) {
        const fecImportId = fecImportIds[index] ?? ''

        if (settled.status === 'fulfilled') {
          result.retriedIds.push(fecImportId)
        } else {
          result.failures.push({ fecImportId, reason: settled.reason })
        }
      }

      return result
    },
    [organization?.id],
  )
}
